"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.npgettext = exports.ngettext = exports.pgettext = exports.gettext = exports.GettextTranslate = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const sprintf_js_1 = require("sprintf-js");
const po_1 = require("./po");
const conversions_1 = require("./conversions");
const plurals = __importStar(require("./plurals"));
const log = (0, debug_1.default)('itp.tools.gettext.translate');
function toTextConversionTypes(conversion) {
    if (_.isString(conversion)) {
        conversion = [conversion];
    }
    const result = [];
    for (let conv of conversion) {
        const tc = getTextConversionValue(conv.replace('Case', ''));
        if (tc) {
            result.push(tc);
        }
    }
    return result;
}
function getTextConversionValue(key) {
    return Object.entries(conversions_1.TextConversionTypes).find(([k, val]) => k === key)?.[1];
}
function interpolatePlural(message, n) {
    if (_.isNumber(n)) {
        return message.replace(/\$\{n\}/gim, n.toString());
    }
    return message;
}
class GettextTranslate {
    defaultLanguage;
    $$language;
    $$silent;
    translations;
    constructor(args) {
        this.defaultLanguage = args.defaultLanguage;
        this.translations = {};
        for (let trans of args.translations) {
            let lang = (0, po_1.getTranslationsLanguage)(trans);
            if (this.translations[lang]) {
                (0, po_1.mergeTranslationsIn)(this.translations[lang], trans);
                continue;
            }
            this.translations[lang] = trans;
        }
        this.$$language = args.defaultLanguage;
        this.$$silent = args.silent || false;
        if (!window.$translate) {
            window.$translate = this;
        }
    }
    get language() {
        return this.$$language;
    }
    set language(value) {
        log('set language to "%s"', value);
        this.$$language = value;
    }
    get silent() {
        return this.$$silent;
    }
    convertInput(conversion, msgid, plural) {
        const ct = toTextConversionTypes(conversion);
        msgid = (0, conversions_1.convertText)(msgid, ct);
        if (plural) {
            plural = (0, conversions_1.convertText)(plural, ct);
        }
        return { msgid, plural };
    }
    interpolateVars(result, n, plural, args) {
        if (result) {
            if (plural && _.isNumber(n)) {
                result = interpolatePlural(result, n);
            }
        }
        return args ? (0, sprintf_js_1.sprintf)(result, args) : result;
    }
    translate(opts) {
        if (!opts.msgid) {
            return '';
        }
        let { msgid, n, context, language, plural, args, conversion } = opts;
        if (!language) {
            language = this.$$language;
        }
        if (n == null) {
            n = 1;
        }
        if (conversion) {
            const converted = this.convertInput(conversion, msgid, plural);
            msgid = converted.msgid;
            plural = converted.plural;
        }
        const silent = this.silent || language === this.$$language;
        const untranslated = plural && plurals.getTranslationIndex(language, n) > 0 ? plural : msgid;
        const translations = this.translations[language];
        if (!translations) {
            if (!silent) {
                console.warn(`No translations found for ${language}`);
            }
            return this.interpolateVars(untranslated, n, plural, args);
        }
        const ctx = translations.translations[context || ''];
        if (!ctx) {
            if (!silent) {
                console.warn(`No context ${context} found. msgid=${msgid}, language=${language}`);
            }
            return this.interpolateVars(untranslated, n, plural, args);
        }
        msgid = msgid.trim();
        const translated = ctx[msgid];
        if (!translated || _.isEmpty(translated)) {
            if (!silent) {
                let msg = `Untranslated ${language} key found: ${msgid}`;
                if (context) {
                    msg += ` context=${context}`;
                }
                console.warn(msg, opts, this.defaultLanguage, this.$$language);
            }
            return this.interpolateVars(untranslated, n, plural, args);
        }
        const translationIndex = translated.msgstr.length === 1 && n === 1
            ? 0
            : plurals.getTranslationIndex(language, n);
        return this.interpolateVars(translated.msgstr[translationIndex], n, plural, args);
    }
    gettext(msgid, language, args) {
        return this.translate({
            msgid,
            language,
            args,
        });
    }
    pgettext(context, msgid, language, args) {
        return this.translate({
            msgid,
            context,
            language,
            args,
        });
    }
    ngettext(msgid, plural, n, language, args) {
        return this.translate({ msgid, n, plural, language, args });
    }
    npgettext(context, msgid, plural, n, language, args) {
        return this.translate({
            msgid,
            n,
            context,
            plural,
            language,
            args,
        });
    }
}
exports.GettextTranslate = GettextTranslate;
function gettext(msgid, language, args) {
    return window.$translate.gettext(msgid, language, args);
}
exports.gettext = gettext;
function pgettext(context, msgid, language, args) {
    return window.$translate.pgettext(context, msgid, language, args);
}
exports.pgettext = pgettext;
function ngettext(msgid, plural, n, language, args) {
    return window.$translate.ngettext(msgid, plural, n, language, args);
}
exports.ngettext = ngettext;
function npgettext(context, msgid, plural, n, language, args) {
    return window.$translate.npgettext(context, msgid, plural, n, language, args);
}
exports.npgettext = npgettext;
//# sourceMappingURL=translate.js.map